<form class="mce-form-section">

    <div class="mce-form-section-title">Load Details</div>

    <div class="mce-form-field-group">

        <div class="flex-grow" [class.mce-form-field-disabled]="calc.loadTypesRx.isLoading()">
            <mat-form-field class="w-full">
                <mat-label>load type</mat-label>
                <mat-select [formField]="form().key">
                    @for (option of calc.loadTypes(); track option.key) {
                    <mat-option [value]="option.key">{{option.description}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field>
                <mat-label>current, Ib</mat-label>
                <input matInput type="number" placeholder="current, Ib"
                       [formField]="form().ib" />
                <span matSuffix>A</span>
                @for (error of form().ib().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        @if (form().case().value() == 'ac') {
            <app-power-factor [form]="form().pf"></app-power-factor>
        }

        @if (requireEfficiency()) {
        <div>
            <mat-form-field>
                <mat-label>efficiency</mat-label>
                <input matInput type="number" placeholder="efficiency"
                       [formField]="form().efficiency" />
                <span matSuffix>point</span>
                @for (error of form().efficiency().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>
        }

    </div>


    <mce-info-message [type]="'information'" class="mb-4">

        @if(form().case().value() == 'dc') {
        <div>
            <button mat-button color="primary" (click)="onClickW()">
                <mat-icon>edit</mat-icon>
            </button>
            Real Power: {{calc.powerDCRx.isLoading() ? 'loading...' : powerDC()}}

        </div>
        }

        @if(form().case().value() == 'ac') {

        <div class="flex gap-8">

            <div>
                <button mat-button type="button" color="primary" (click)="onClickW()">
                    <mat-icon>edit</mat-icon>
                    Real Power: {{calc.powerACRx.isLoading() ? 'loading...' : powerAC()}}
                </button>

            </div>
            <div>
                <button mat-button type="button" color="primary" (click)="onClickVA()">
                    <mat-icon>edit</mat-icon>
                Apparent power: {{calc.powerACRx.isLoading() ? 'loading...' : kvaAC()}}
                </button>
            </div>
        </div>

        }

    </mce-info-message>

</form>




